module.exports = __webpack_public_path__ + "img/4.e57e3ee4.jpg";